import {colors, datetime, objects, strings} from "@atttomyx/shared-utils";
import {colors as constants} from "@atttomyx/shared-constants";
import {COLOR, COLORS, DATE_HIDDEN} from "../constants";

const COLORS_BY_LABEL = {};
const BRIGHT_BY_COLOR = {};
const HASH_TO_COLOR = {};
let AVAILABLE = 0;

const initColors = () => {
    let h = 0;

    COLORS.forEach(color => {
        HASH_TO_COLOR[h++] = color;
    });

    AVAILABLE = h;
};

initColors();

const getColor = (label) => {
    if (!COLORS_BY_LABEL[label]) {
        const hash = Math.abs(strings.hashCode(label)) % AVAILABLE;

        COLORS_BY_LABEL[label] = HASH_TO_COLOR[hash];
    }

    return COLORS_BY_LABEL[label];
};

const getTextColor = (color) => {
    if (!BRIGHT_BY_COLOR[color]) {
        BRIGHT_BY_COLOR[color] = colors.isBright(color, 300);
    }

    return BRIGHT_BY_COLOR[color] ? constants.BLACK : constants.WHITE;
};

export const getContentHeight = () => {
    const screen = window.screen;

    return screen.height - 224;
};

export const nodeToEvent = (node, date, who, when, i) => {
    const backgroundColor = getColor(date.label);
    const textColor = getTextColor(backgroundColor);

    return {
        id: `${node.id}_${i}`,
        title: who,
        start: when,
        end: when,
        color: backgroundColor,
        textColor: textColor,
        extendedProps: {
            node: node,
            date: date,
        },
    }
};

export const taskToEvent = (task) => {
    const when = objects.defaultIfNullOrUndefined(task.dueAt, task.dueOn);
    const title = task.dueAt ? `${datetime.getPrettyTime(task.dueAt)} - ${task.title}` : task.title;

    return {
        id: task.id,
        title: title,
        start: when,
        end: when,
        color: COLOR,
        textColor: constants.WHITE,
        extendedProps: {
            task: task,
        },
    }
};

export const isVisible = (date, dateModes) => {
    const mode = dateModes[date.label];

    return mode !== DATE_HIDDEN;
};
